// extracted by mini-css-extract-plugin
export default {"root":"QwDODsBWs4Q0AF9XcOYE","placeHolderShimmer":"JzrPGMgzbaHYZTu8lO5l"};